import { Component, OnInit, ViewChild, ViewEncapsulation, Inject, ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { GlobalComponent } from 'src/app/global/global.component';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { FilterSettingsModel, IFilter, DataStateChangeEventArgs, RowSelectEventArgs } from '@syncfusion/ej2-grids';
import { GridComponent, DetailRowService, SelectionService, parentsUntil, QueryCellInfoEventArgs, GridModel, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { IMyDateModel, IMyDpOptions, IMyInputFieldChanged } from 'mydatepicker';
import { DatePipe } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import { DateService } from 'src/app/date.service';
import { SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { takeUntil } from 'rxjs/operators';
import { functionpermission, GetRetuenPayrollBo, PaidBO, UnPaidBo } from './payroll.model';
import { ColumnChangeBO, columnWidth, WhereCondition } from '../list/list.model';
import { GeneralService } from 'src/app/service/general.service';
import { ToastrService } from 'ngx-toastr';
import { PaidHTTPService } from './payrollpaid.service';
import { UnpaidHTTPService } from './payrolldata.service';
import { PayrollHttpService } from './payroll.service';
import { EmployeeService } from '../employee/employee.service';
@Component({
  selector: 'app-payroll',
  templateUrl: './payroll.component.html',
  styleUrls: ['./payroll.component.scss'],
  providers: [SelectionService, DetailRowService]
})



export class PayrollComponent implements OnInit {
  enabledClientBoolean: boolean = true;
  enabledMileBoolean: boolean = true;

  isEnabledExcel: boolean;
  Employeedropdown: any = [];
  clientAlldropdown: any = [];
  employeeFilterList: any;
  clientdropdown: any = []
  validPassword: boolean = false;
  deletepassword: boolean = false;
  locationId: string = "00000000-0000-0000-0000-000000000000";
  PrivatePayUnLockArrayList: any = [];
  PrivatePayLockArrayList: any = [];
  isCheckedBool: boolean = false;
  clientFilterList: any;
  public selectionOptions: SelectionSettingsModel;
  isPaidCheckedBool: boolean = false;
  isUnLockedCheckedBool: boolean = false;
  lockedAmount: any = [];
  UnlockedAmount: any = [];
  filterStartDate: any = null;
  filterEndDate: any = null;
  filterPayDate: any = null;
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('gridpaid') public gridpaid: GridComponent;

  filterOptions: FilterSettingsModel;
  public selectOptions: Object;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: string = "00000000-0000-0000-0000-000000000000";
  public editSettings: Object;
  public toolbar: string[];

  arraycol: any = [];
  ColumnArray_UnLocked: columnWidth[];
  ColumnArray_Locked: columnWidth[];
  public formatOptions: object;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true
  };
  public PayDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    //disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  PayrollListBo: GetRetuenPayrollBo = new GetRetuenPayrollBo();

  conditionlist: WhereCondition[] = [];
  UnLockedDataList: any = [];
  LockedDataList: any = [];
  conditionData: WhereCondition = new WhereCondition();
  type: string = "";
  public initialPage: PageSettingsModel;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public filterSettings: object;
  public data: Observable<DataStateChangeEventArgs>;
  PrivatePaySelectedTab = "UnPaid";
  isPrivatePayData: boolean = false;
  private onDestroy$: Subject<void> = new Subject<void>();
  IsButtonDisable: boolean = false;
  PaidPayrollCount: any;
  UnPaidPayrollCount: any;
    ApproveFilter:any="all";
  constructor(private datePipe: DatePipe, private employeeService: EmployeeService, public http: HttpClient, private formBuilder: FormBuilder, @Inject(UnpaidHTTPService) public UnPaidService: UnpaidHTTPService, public datepipe: DatePipe, public PaidSservice: PaidHTTPService, private ref: ChangeDetectorRef, public global: GlobalComponent, public PayrollService: PayrollHttpService, public toasterService: ToastrService, public general: GeneralService, public dateservice: DateService, private cdr: ChangeDetectorRef, @Inject(ViewContainerRef) private viewContainerRef?: ViewContainerRef
  ) {
    this.global.checkforlogout();
    this.data = PaidSservice;
    this.GridList = UnPaidService;
  }
  @ViewChild('childtemplateLpr') public childtemplateLpr: any;
  childGrid: GridModel;
  public checkparams;
  fp: functionpermission = new functionpermission()
  ngOnInit(): void {
    this.getpermission()
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.filterSettings = { type: 'Menu' }
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };
    this.checkparams =
    {
      checked: false
    }

    this.filterStartDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.filterEndDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();

    if (this.global.globalAgencyId != null && this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
      this.getEmployeeDropDown();
      this.getAllClientDropDown();
      this.ApplyFilter();
      this.getServiceList();
      if (this.global.globalLocationId == null || this.global.globalLocationId == undefined || this.global.globalLocationId == '') {
        this.locationId = "00000000-0000-0000-0000-000000000000"
      }
      else {
        this.locationId = this.global.globalLocationId;
      }
    }


    this.selectionOptions = {
      checkboxOnly: true
    };

    this.childGrid = {
      queryString: 'timesheetId',
      allowSorting: false,
      allowPaging: false,
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false },

      columns: [
        { field: 'clientName', headerText: 'Client', minWidth: 100, },
        { field: 'employeeName', headerText: 'Employee', minWidth: 100, },
        { field: 'serviceName', headerText: 'service', minWidth: 80 },
        { field: 'serviceDate', headerText: 'Timesheet Date', minWidth: 100 },
        { field: 'rate', headerText: 'PayRate', minWidth: 70 },
        { field: 'hours', headerText: 'Total Hours', minWidth: 70 },
        { field: 'totalAmount', headerText: 'Total Amount', minWidth: 100 },

      ]
    };




    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "PAYROLL");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.PayrollService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }


  //  EmployeeDropDown..............................................................................................
  getEmployeeDropDown() {

    this.PayrollService.GetAllEmployeesDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.Employeedropdown = data;
      this.Employeedropdown.forEach(e => {
        e.Key = e.Key
        e.Value = e.Value
      });
    },
      err => {
        this.toasterService.error(err);
      });
  }

  ///////////clientdrop////////////////
  getAllClientDropDown() {

    this.PayrollService.GetAllClientDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      this.clientAlldropdown = data
      this.clientAlldropdown.forEach(e => {
        e.Key = e.Key
        e.Value = e.Value
      });
    },
      err => {
        this.toasterService.error(err);
      });
  }


  ////////filter/////////////
  ApplyFilter() {
    if (this.filterStartDate != null && this.filterStartDate != '' && this.filterStartDate != undefined && this.filterEndDate != null && this.filterEndDate != '' && this.filterEndDate != undefined) {

      if (new Date(this.filterStartDate).getTime() > new Date(this.filterEndDate).getTime()) {
        this.toasterService.error("End date should greater than start date")
        return;
      }
    }

    if (this.filterStartDate != null && this.filterStartDate != undefined && this.filterStartDate != '') {
      this.PayrollListBo.startTime = this.global.getDateTimeString(this.filterStartDate);
    }
    if (this.filterEndDate != null && this.filterEndDate != undefined && this.filterEndDate != '') {
      this.PayrollListBo.endTime = this.global.getDateTimeString(this.filterEndDate);
    }
    if (this.filterPayDate != null && this.filterPayDate != undefined && this.filterPayDate != '') {
      this.PayrollListBo.paidDate = this.global.getDateTimeString(this.filterPayDate);
    }
    this.PayrollListBo.employeeId = this.employeeFilterList != null ? this.employeeFilterList : null;
    this.PayrollListBo.clientId = this.clientFilterList != null ? this.clientFilterList : null;
    this.PayrollListBo.isApproved=this.ApproveFilter == "all" ? null:(this.ApproveFilter == "approved"? true :false);
    if (this.PrivatePaySelectedTab == 'UnPaid') {
      this.getUnpaidListFilter();
    }
    else {
      this.getpaidlistfilter();
    }
  }
  ClearFilter() {
    this.PayrollListBo = new GetRetuenPayrollBo();

    this.filterEndDate = null;
    this.filterPayDate = null;
    this.filterStartDate = null;
    this.employeeFilterList = null;
    this.clientFilterList = null;
  }
  Refresh() {
    this.PayrollListBo = new GetRetuenPayrollBo();
    this.employeeFilterList = null;
    this.clientFilterList = null;
    this.filterPayDate = '';
    if (this.PrivatePaySelectedTab == 'UnPaid') {
      
      this.getUnpaidListFilter();
    }
    else {
      this.getpaidlistfilter();
    }

    // this.grid.clearFiltering();
    // this.grid.clearSorting();
    this.parentData = [];
    this.childData = [];
  }


  switchChanges() {
    // this.PayrollListBo.isArchieved = this.isPrivatePayData;
    this.ApplyFilter();
  }
  //.....................Creating and Updating.................................................................




  totalhoursSummaryMinutes: string;
  totalhoursSummary: number = 0;
  public GridList: Observable<DataStateChangeEventArgs>;
  showTotalamount: any;
  unpaidlist: any = [];
  //............................................... UnpaidPayroll List.....................................................................

  getUnpaidListFilter() {

    if ((this.filterStartDate == null || this.filterStartDate == '' || this.filterStartDate == undefined) &&
      this.filterEndDate != null && this.filterEndDate != '' && this.filterEndDate != undefined) {
      this.toasterService.error("Please select start date")
      return;
    }
    if (this.filterStartDate != null && this.filterStartDate != '' && this.filterStartDate != undefined && this.filterEndDate != null && this.filterEndDate != '' && this.filterEndDate != undefined) {

      if (new Date(this.filterStartDate).getTime() > new Date(this.filterEndDate).getTime()) {
        this.toasterService.error("End date should greater than start date")
        return;
      }
    }

    this.PayrollListBo.startTime = this.global.getDateTimeString(this.filterStartDate);
    this.PayrollListBo.endTime = this.global.getDateTimeString(this.filterEndDate);
    this.PayrollListBo.paidDate = (this.filterPayDate != null && this.filterPayDate != undefined && this.filterPayDate != '') ? this.global.getDateTimeString(this.filterPayDate) : null;
    this.PayrollListBo.isPaid = false;

    this.UnPaidService.execute(this.PayrollListBo);

    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.unpaidlist = data.result;
      this.UnPaidPayrollCount = data?.count;
      if (data != null && data.result.length >= 10) {
        this.grid.height = "auto";
      } else {
        this.grid.height = "auto";
      }
    })

  }

  ///////////getPaidPayroll List ///////////////
  public childData: any = [];
  parentData: any = [];
  parentpaidlist: any = [];
  childpaidlist: any = [];

  getpaidlistfilter() {

    this.PayrollListBo.isPaid = true;
    this.PayrollListBo.startTime = this.global.getDateTimeString(this.filterStartDate);
    this.PayrollListBo.endTime = this.global.getDateTimeString(this.filterEndDate);
    this.PayrollListBo.paidDate = (this.filterPayDate != null && this.filterPayDate != undefined && this.filterPayDate != '') ? this.global.getDateTimeString(this.filterPayDate) : null;

    this.PaidSservice.executepaid(this.PayrollListBo);

    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.parentpaidlist = data.result;
      this.parentData = data.result;
      this.PaidPayrollCount = data?.count;
      this.childData = this.PaidSservice.getChildData();
      this.gridpaid.childGrid.dataSource = this.childData;
      this.gridpaid.childGrid.columns = [

        { field: 'clientName', headerText: 'Client', minWidth: 100, },
        { field: 'employeeName', headerText: 'Employee', minWidth: 100, },
        { field: 'serviceName', headerText: 'service', minWidth: 80 },
        { field: 'serviceDate', headerText: 'Timesheet Date', minWidth: 100 },
        { field: 'rate', headerText: 'PayRate', minWidth: 70 },
        { field: 'hours', headerText: 'Total Hours', minWidth: 70 },
        { field: 'totalAmount', headerText: 'Total Amount', minWidth: 100 },
      ]

      if (data != null && data.result.length >= 10) {
        this.gridpaid.height = "auto";
      } else {
        this.gridpaid.height = "auto";
      }
    })

  }




  //........................................TAPCHANGE.......................................

  tabchange(val) {
    this.PrivatePaySelectedTab = val;

    if (this.PrivatePaySelectedTab == 'UnPaid') {
      this.getUnpaidListFilter();

    }
    else {
      this.getpaidlistfilter()
    }
  }

  SaveColumnwidth() {
    this.arraycol[0].Locked_Private_Pay.Columns = this.ColumnArray_Locked;
    this.arraycol[0].UnLocked_Private_Pay.Columns = this.ColumnArray_UnLocked;
    this.arraycol[0].Locked_Private_Pay.Pagesize = this.grid.pageSettings.pageSize;
    this.arraycol[0].UnLocked_Private_Pay.Pagesize = this.grid.pageSettings.pageSize;
    this.columnchange.agencyId = this.global.globalAgencyId;
    this.columnchange.userid = this.global.userID;
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.PayrollService.savecolumwidth(this.columnchange).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      // this.getColumnwidth();
    });
  }

  payDateChanges(event, type, name) {
    if (type == "inputchanged") {

      if (name == 'startDate') {
        let element = this.dateservice.inputFeildchange(event);
        if (element != undefined) {
          let values = this.dateservice.inputFeildchange(event);
          this.filterStartDate = values;
        }
      }
      if (name == 'endDate') {
        let element = this.dateservice.inputFeildchange(event);
        if (element != undefined) {
          let values = this.dateservice.inputFeildchange(event);
          this.filterEndDate = values;
        }
      }
      if (name == 'payDatedFilter') {
        let element = this.dateservice.inputFeildchange(event);
        if (element != undefined) {
          let values = this.dateservice.inputFeildchange(event);
          this.filterPayDate = values;
        }
      }
      if (name == 'serviceDate') {
        let element = this.dateservice.inputFeildchange(event);
        if (element != undefined) {
          let values = this.dateservice.inputFeildchange(event);
          // this.savePrivatePay.serviceDate = values;
        }
      }
    }
    if (type == "datechanged") {

      if (name == 'serviceDate') {
        let element = this.dateservice.Datechange(event);
        if (element != undefined) {
          let values = this.dateservice.Datechange(event);
          // this.savePrivatePay.serviceDate = values;
          // this.getClientDropDown();
        }
      }
      if (name == 'startDate') {
        let element = this.dateservice.Datechange(event);
        if (element != undefined) {
          let values = this.dateservice.Datechange(event);
          this.filterStartDate = values;
        }
      }
      if (name == 'endDate') {
        let element = this.dateservice.Datechange(event);
        if (element != undefined) {
          let values = this.dateservice.Datechange(event);
          this.filterEndDate = values;
        }
      }
      if (name == 'payDatedFilter') {
        let element = this.dateservice.Datechange(event);
        if (element != undefined) {
          let values = this.dateservice.Datechange(event);
          this.filterPayDate = values;
        }
      }
    }
  }

  exportPrivatePayCsv() {
    this.PayrollService.exportMileageLogs(this.PayrollListBo);
  }


  SaveList: PaidBO = new PaidBO();

  showerr: any = ""
  selectedpayrollid: any = [];
  payrollPayDate: string = null;
  mulitpledata: any = [];
  selectAllValue: any;
  Type: any;
  TimesheetLst: any = [];


  ///////////////////////onaction complete ///////////////////
  actionBegin(L) {

    this.PayrollListBo.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.PayrollListBo.pageitem = this.grid.pagerModule.pagerObj.pageSize;

  }


  actionBeginpaid(L) {

    this.PayrollListBo.currentpageno = this.gridpaid.pagerModule.pagerObj.currentPage;
    this.PayrollListBo.pageitem = this.gridpaid.pagerModule.pagerObj.pageSize;
  }


  /////////////////////datastatechange/////////////////////////////////

  public dataStateChange(Timesheet): void {
    let val = (Timesheet.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((Timesheet.sorted || []).length) {
        this.PayrollListBo.orderColumn = Timesheet.sorted[0].name;
        this.PayrollListBo.orderType = Timesheet.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && Timesheet.action.action != "clearFilter") {
      this.PayrollListBo.value = Timesheet.action.currentFilterObject.value;
      this.PayrollListBo.field = Timesheet.action.currentFilterObject.field;
      this.PayrollListBo.matchCase = Timesheet.action.currentFilterObject.matchCase;
      this.PayrollListBo.operator = Timesheet.action.currentFilterObject.operator;

      if (this.PayrollListBo.type == "number") {
        this.PayrollListBo.value = Timesheet.action.currentFilterObject.value.toString();
        this.PayrollListBo.field = Timesheet.action.currentFilterObject.field;
      }
    }
    else {
      if (val == "filtering" && Timesheet.action.action == "clearFilter") {
        this.PayrollListBo.field = "ClientName";
        this.PayrollListBo.matchCase = false;
        this.PayrollListBo.operator = "contains";
        this.PayrollListBo.value = "";
        this.PayrollListBo.type = "string";
      }
    }


    this.getUnpaidListFilter();



    if (val == "paging" && Timesheet.action.name == "actionBegin") {

    }
  }

  public dataStateChange1(Timesheet): void {
    let val = (Timesheet.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((Timesheet.sorted || []).length) {
        this.PayrollListBo.orderColumn = Timesheet.sorted[0].name;
        this.PayrollListBo.orderType = Timesheet.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && Timesheet.action.action != "clearFilter") {
      this.PayrollListBo.currentpageno = this.gridpaid.pagerModule.pagerObj.currentPage;
      this.PayrollListBo.pageitem = this.gridpaid.pagerModule.pagerObj.pageSize;
      this.PayrollListBo.value = Timesheet.action.currentFilterObject.value;
      this.PayrollListBo.field = Timesheet.action.currentFilterObject.field;
      this.PayrollListBo.matchCase = Timesheet.action.currentFilterObject.matchCase;
      this.PayrollListBo.operator = Timesheet.action.currentFilterObject.operator;

      if (this.PayrollListBo.type == "number") {
        this.PayrollListBo.value = Timesheet.action.currentFilterObject.value.toString();
        this.PayrollListBo.field = Timesheet.action.currentFilterObject.field;
      }
    }
    else {
      if (val == "filtering" && Timesheet.action.action == "clearFilter") {
        this.PayrollListBo.currentpageno = this.gridpaid.pagerModule.pagerObj.currentPage;
        this.PayrollListBo.pageitem = this.gridpaid.pagerModule.pagerObj.pageSize;
        this.PayrollListBo.field = "ClientName";
        this.PayrollListBo.matchCase = false;
        this.PayrollListBo.operator = "contains";
        this.PayrollListBo.value = "";
        this.PayrollListBo.type = "string";
      }
    }

    this.PayrollListBo.currentpageno = this.gridpaid.pagerModule.pagerObj.currentPage;
    this.PayrollListBo.pageitem = this.gridpaid.pagerModule.pagerObj.pageSize;
    this.getpaidlistfilter();



    if (val == "paging" && Timesheet.action.name == "actionBegin") {

    }
  }


  rowDataBound(args) {


    if (args.data.payrollPayRateBO['totalAmount'] == null || args.data.payrollPayRateBO['totalAmount'] == undefined || args.data.payrollPayRateBO['totalAmount'] == '') {

      args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox');

      args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox')



    }

  }


  /////////////////////Edit PayDate//////////////////
  editPaydate(args) {
    var grid = (parentsUntil(args.target, 'e-grid') as any);
    let val = grid.ej2_instances[0].getRowInfo(args.target).rowData;

    if (val?.payDate != null || val?.payDate != undefined || val?.payDate != '') {
      this.payrollPayDate = (val.payDate != '' && val.payDate != null && val.payDate != undefined) ? this.datepipe.transform(val.payDate, "MM/dd/yyyy") : '';
    }

    if (this.PrivatePaySelectedTab == 'UnPaid') {
      this.selectedpayrollid = [];
      this.selectedpayrollid.push(val);
    }
    else {
      this.selectedpayrollid = [];
      this.selectedpayrollid.push(val.id);

    }
  }

  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  saveErr: string = "";
  payrollPayDateChanged = false;




  /////////////////////////////////Update PayDate////////////////////////////
  UpdatePaydate() {
    this.IsButtonDisable = true;
    if (this.PrivatePaySelectedTab == 'UnPaid') {
      var paydate = this.payrollPayDate != null && this.payrollPayDate != undefined && this.payrollPayDate != "" ? (new Date(new Date(this.payrollPayDate).toDateString() + " "
        + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : "";
      let myParams: UnPaidBo = {
        UnPaidPayrollBO: this.selectedpayrollid,
        payDate: paydate
      }


      this.PayrollService.UnPaidUpdatePaydate(myParams).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
        this.IsButtonDisable = false;
        this.getUnpaidListFilter();
        this.payrollPayDateChanged = false;
        document.getElementById('OpenModal3').click();
        this.toasterService.success('Pay date updated successfully!');
        setTimeout(() => {
          this.toasterService.clear();
        }, 8000);

      },
        (err: HttpErrorResponse) => {
          this.IsButtonDisable = false;
          this.saveErr = err.error
        });

    }
    else {
      this.updatepaidPayDate();
    }

  }

  updatepaidPayDate() {

    var paydate = this.payrollPayDate != null && this.payrollPayDate != undefined && this.payrollPayDate != "" ? (new Date(new Date(this.payrollPayDate).toDateString() + " "
      + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : "";
    let myParams: PaidBO = {
      payrollIds: this.selectedpayrollid,
      payDate: paydate
    }

    this.PayrollService.PaidUpdatePayDate(myParams).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.IsButtonDisable = false;
      this.payrollPayDateChanged = false;
      this.paidboolean = false
      document.getElementById('OpenModal3').click();
      this.toasterService.success('Pay date updated successfully!');
      setTimeout(() => {
        this.toasterService.clear();
      }, 8000);
      this.getpaidlistfilter();

    },
      (err: HttpErrorResponse) => {
        this.IsButtonDisable = false;
        this.saveErr = err.error
      });
  }





  PayrollPaidonDate: string;
  idlist: any = [];
  employee: any = '';
  client: any = '';

  updatevalchange: boolean = false;



  editPayrollPaydate(event: IMyInputFieldChanged) {
    this.payrollPayDateChanged = true;
    let value = event.value;
    console.log(value, "value");
    if (value.length == 5 && value.substring(2, 3) != '/') {
      this.payrollPayDate = value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4, 10);
    }


    // if (value.length ==10) {
    //   if( new Date(event.value) > new Date()) {
    //     this.toasterService.error("PayDate should not be future");
    //     this.payrollPayDate = '';

    //   }     
    // }
  }

  editPayrollPaydatechage(event: IMyDateModel) {
    this.payrollPayDateChanged = true;
    this.payrollPayDate = event.formatted;
    // if (new Date(this.payrollPayDate) > new Date()) {
    //   this.toasterService.error("PayDate should not be future");
    //   this.payrollPayDate = '';
    //   console.log(this.payrollPayDate)
    // }
  }


  newdates(event, name, refname) {

    if (name == "inputchage") {
      let val = this.dateservice.inputFeildchange(event);
      if (val != undefined) {
        let val1 = this.dateservice.inputFeildchange(event);

        if (refname == "pay") {
          this.SaveList.payDate = val1;
        }

      }
    }
    if (name == "datechagned") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let val1 = this.dateservice.Datechange(event);

        if (refname == "pay") {
          this.SaveList.payDate = val1;
        }

      }
    }
  }




  ///////////////////checkbox Changes////////////
  selectedunpaidid: any = [];
  checkboxunpaidchange(args) {

    var customselect = [];
    this.selectedpayrollid = [];
    if (args.checked && args.target.classList.contains("e-checkselectall")) {

      for (var i = 0; i < args.selectedRowIndexes.length; i++) {

        var row = this.grid.getRowByIndex(args.selectedRowIndexes[i]);

        if (!row.querySelector('.disablecheckbox')) {
          this.selectedpayrollid = []
          customselect.push(args.selectedRowIndexes[i])


        }

      }
      console.log(customselect, "customselect")
      this.grid.selectRows(customselect)
      this.unpaidlist.forEach((e, index) => {
        customselect.forEach(element => {
          console.log(element, "eeeeeee")
          if (element == index) {

            this.selectedpayrollid.push(e);
          }
        })

      })
    }

    else if (args.target.classList.contains("e-checkselect")) {

      let rowsdata: any = this.grid.getSelectedRecords();

      this.selectedpayrollid = rowsdata.filter(t => t.clientId != undefined && t.clientId != null && t.clientId != '').map(d => d)


      for (var i = 0; i < args.selectedRowIndexes.length; i++) {

        var row = this.grid.getRowByIndex(args.selectedRowIndexes[i]);

        if (!row.querySelector('.disablecheckbox')) {

          customselect.push(args.selectedRowIndexes[i])

        }

      }

      this.grid.selectRows(customselect)
    }
  }


  paidboolean: boolean = false;
  checkboxpaidchange(args) {

    if (args.checked == true) {
      this.paidboolean = true
    }
    else {
      this.paidboolean = false
    }

    this.selectedpayrollid = [];
    if (args.checked && args.target.classList.contains("e-checkselectall")) {
      this.parentpaidlist.forEach(element => {

        this.selectedpayrollid.push(element.id);


      });



    }

    else if (args.target.classList.contains("e-checkselect")) {

      let rowsdata: any = this.gridpaid.getSelectedRecords();

      this.selectedpayrollid = rowsdata.filter(t => t.clientId != undefined && t.clientId != null && t.clientId != '').map(d => d.id)

    }
  }




  ///////move to unpaid//////////

  MovetoUnPaid() {
    this.IsButtonDisable = true;
    this.PayrollService.MovedToUnpaid(this.selectedpayrollid).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.IsButtonDisable = false;


      this.selectedpayrollid = [];
      this.paidboolean = false
      this.toasterService.success('Moved to Unpaid successfully!');
      document.getElementById('OpenModal4').click()

      setTimeout(() => {

        this.toasterService.clear();

      }, 8000);
      this.getpaidlistfilter();
    },

      (err: HttpErrorResponse) => {
        this.IsButtonDisable = false;
        this.toasterService.error(err.error, 'error');

        setTimeout(() => {

          this.toasterService.clear();

        }, 8000);

      })

  }

  clearpaydate() {
    this.payrollPayDate = '';
  }


  exportCsv(data) {
    let url = this.PrivatePaySelectedTab == "UnPaid" ? "api/Payroll/UnPaidPayorllExport" : "api/Payroll/PaidPayorllExport";
    if (this.PrivatePaySelectedTab == "Paid")
      this.PayrollListBo.pageitem = data == 'current' ? this.PayrollListBo.pageitem : this.PaidPayrollCount;
    if (this.PrivatePaySelectedTab == "UnPaid")
      this.PayrollListBo.pageitem = data == 'current' ? this.PayrollListBo.pageitem : this.UnPaidPayrollCount;
    this.PayrollService.exportcsv(this.PayrollListBo, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      let contentType = 'text/csv';
      const blob = this.b64toBlob(data.fileContents, contentType);
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = "Payroll Export";
      a.click();
      document.getElementById("exportascsv").click();
    },
      (err: HttpErrorResponse) => {
        this.toasterService.error(
          err.error

        );
      })

  }

  b64toBlob = (b64Data, contentType: any, sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }



  serviceList: any = []
  getServiceList() {

    this.employeeService.getServicedropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.serviceList = data


    })
  }

}





